import { recordFromSnapshot } from 'utils/firebaseUtils'
import moment from 'moment'
import _ from 'lodash'
// import { initDaySliderValues } from './PlanningHelper'
// import { updateTransactionsWithPlayer } from './transaction'
// import moment from 'moment'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_PLAYER_ERROR = 'CREATE_PLAYER_ERROR'
export const CREATE_PLAYER_SUCCESS = 'CREATE_PLAYER_SUCCESS'
export const DELETE_PLAYER_ERROR = 'DELETE_PLAYER_ERROR'
export const DELETE_PLAYER_SUCCESS = 'DELETE_PLAYER_SUCCESS'
export const UPDATE_PLAYER_ERROR = 'UPDATE_PLAYER_ERROR'
export const UPDATE_PLAYER_SUCCESS = 'UPDATE_PLAYER_SUCCESS'
export const SELECT_PLAYER = 'SELECT_PLAYER'
// ------------------------------------
// Logic Actions
// ------------------------------------

export function selectPlayer(player) {
  return (dispatch, getState) => {
    dispatch({ type: SELECT_PLAYER, payload: player })
  }
}
export function updatePlanning(player, changes) {
  return (dispatch, getState) => {
    dispatch(updatePlayer(player, { changes }))
  }
}
// ------------------------------------
// Basic Actions
// ------------------------------------
export function reorderPlayers(orderedPlayers) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    let fanoutObject = {}
    let counter = 1
    orderedPlayers.forEach(p => {
      fanoutObject['/players/' + p.key + '/order'] = counter
      counter++
    })
    firebase.update(fanoutObject)
  }
}

export function createPlayer({ name, reduc }) {
  return (dispatch, getState) => {
    const { firebase, players, auth } = getState()
    let nextOrder = 0
    players.list.forEach(p => {
      if (nextOrder < p.order) {
        nextOrder = p.order
      }
    })
    nextOrder++
    const now = moment().format()
    const player = {
      createdBy: auth.hbUserKey,
      updatedBy: auth.hbUserKey,
      createdAt: now,
      updatedAt: now,
      name: name,
      reduc: reduc,
      order: nextOrder
    }
    firebase.child('players').push(player, error => {
      if (error) {
        console.error('ERROR @ createPLAYER :', error)
        dispatch({
          type: CREATE_PLAYER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function deletePlayers(players) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    players = _.isArray(players) ? players : [players]
    let fanout = {}
    for (let i = 0; i < players.length; i++) {
      fanout[`players/${players[i].key}`] = null
    }
    firebase.update(fanout, error => {
      if (error) {
        console.error('ERROR @ deletePLAYER :', error)
        dispatch({
          type: DELETE_PLAYER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function updatePlayer(player, changes) {
  return (dispatch, getState) => {
    const { firebase, auth } = getState()
    changes.updatedBy = auth.hbUserKey
    changes.updatedAt = moment().format()
    firebase.child('players/' + player.key).update(changes, error => {
      if (error) {
        console.error('ERROR @ updatePlayer :', error)
        dispatch({
          type: UPDATE_PLAYER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function registerPlayersListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('players')
    ref.orderByChild('order').on('child_added', snapshot => {
      let player = recordFromSnapshot(snapshot)
      dispatch({
        type: CREATE_PLAYER_SUCCESS,
        payload: player
      })
    })

    ref.on('child_changed', snapshot => {
      dispatch({
        type: UPDATE_PLAYER_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
      // dispatch(updateTransactionsWithPlayer(recordFromSnapshot(snapshot)))
    })

    ref.on('child_removed', snapshot =>
      dispatch({
        type: DELETE_PLAYER_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )
  }
}

export const actions = {
  createPlayer,
  updatePlayer,
  registerPlayersListeners,
  selectPlayer
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SELECT_PLAYER]: (state, action) =>
    Object.assign({}, state, { selectedPlayer: action.payload }),
  [CREATE_PLAYER_SUCCESS]: (state, action) => {
    let list
    let tmpList = state.list.slice()
    tmpList = tmpList.filter(player => player.key === action.payload.key)
    if (tmpList.length === 0) {
      list = [...state.list, action.payload]
    } else {
      list = [...state.list]
    }
    list.sort((a, b) => a.order < b.order)
    return Object.assign({}, state, { list: list })
  },
  [CREATE_PLAYER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_PLAYER_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.map(player => {
        return player.key === action.payload.key ? action.payload : player
      })
    }),
  [UPDATE_PLAYER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_PLAYER_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.filter(player => {
        return player.key !== action.payload.key
      })
    }),
  [DELETE_PLAYER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], selectedPlayer: {} }
export default function playerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/player.js